import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export function emailMatchValidator(_controlName: string, _matchingControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const emailControl = formGroup.get('email');
    const verifyEmailControl = formGroup.get('verifyEmail');

    if (!emailControl || !verifyEmailControl) {
      return null;
    }

    const email = emailControl.value;
    const verifiedEmail = verifyEmailControl.value;

    if (email !== verifiedEmail) {
      verifyEmailControl.setErrors({ emailMismatch: true });
    }

    return null;
  };
}
